module.exports = __webpack_public_path__ + "img/section6-1-mobile.7ada9d81.png";